import { useState } from 'react';

export default function Contact() {
  const [status, setStatus] = useState("Submit");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    const response = await fetch("https://formspree.io/f/movdegpg", {
      method: "POST",
      headers: {
        Accept: "application/json",
      },
      body: new FormData(e.target),
    });

    if (response.ok) {
      setStatus("Sent!");
      e.target.reset();
    } else {
      setStatus("Error!");
    }
  };

  return (
    <div className="contact-wrapper">
      <span className="projects-comment">{"// let's talk"}</span>
      <h2 className="code-header" style={{ marginBottom: "1rem" }}>
        <span className="keyword">print</span>
        <span className="punctuation">(</span>
        <span className="string">"contact"</span>
        <span className="punctuation">)</span>
      </h2>

      <p className="contact-intro">
        I am always open to new opportunities and collaborations! Feel free to reach out to me through the form below or connect with me on LinkedIn, whether you have a question, want to discuss research, or just say hi.
      </p>

      <form onSubmit={handleSubmit} className="contact-form">
        <label htmlFor="name">Name:</label>
        <input type="text" id="name" name="name" required />

        <label htmlFor="email">Email:</label>
        <input type="email" id="email" name="email" required />

        <label htmlFor="message">Message:</label>
        <textarea id="message" name="message" rows="5" required />

        <button type="submit">{status}</button>
      </form>
    </div>
  );
}
